import React from 'react';
import LazyLoad from 'react-lazyload';

import SimpleVideoPlayer from '../blogComponents/SimpleVideoPlayer';

import './FeaturedSection.css';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

import { buildAnchorCheckoutLink, buildAnchorLink } from '../../utils/helpers';

import moment from 'moment';
import { UserContext } from '../../context';
import { observer } from 'mobx-react';
import AnchorStore from '../../store/AnchorStore';

@observer
class FeaturedItem extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
      }

  renderPlayIcon = () => {
    if (this.props.type !== 'clipstore') {
      return null;
    }

    return <PlayArrowIcon />;
  };

  renderContent = () => {
    const { featuredItem, loggedInUser, type } = this.props;
    const clip = {
      clipUrl: featuredItem?.clipUrl,
      imageUrl: featuredItem?.imageUrl,
    };
    const imageSrc = featuredItem?.programSegments?.[0]?.clip?.thumbnailImageUrl ||
      featuredItem.thumbnailImageUrl || featuredItem.image || featuredItem.imageUrl ||
      featuredItem.clip.thumbnailImageUrl || featuredItem.clip.imageUrl || featuredItem?.asset;
    if (featuredItem?.clipUrl?.endsWith('null') || !featuredItem?.clipUrl) {

      return (
        <div className="content-item-thumbnail">
          {this.renderPlayIcon()}
          <img alt="Xlthumb placeholder" src={imageSrc} style={{ opacity: 1 }} />
        </div>
      );
    }

    return (
      <div className="content-featured-clip">
        <SimpleVideoPlayer
          autoPlayVideo={false}
          clip={clip}
          fanZoneFreeVideo={loggedInUser !== undefined}
          isFeaturedClip={true}
          user={loggedInUser}
          videoClass={true}
        />
      </div>
    );
  };

  getUrlForItem = () => {
    const { type, featuredItem } = this.props;
    const { user } = this.context;
    const { anchors } = AnchorStore;
    if (user?.account?.activeSubscription && type === 'featured') {
      return featuredItem?.url;
    }

    if (type === 'clipstore') {
      let featuredItemAnchor = anchors?.currentAnchors?.find((anchor) => anchor.id === featuredItem.anchorId);
      if (!featuredItemAnchor) {
        featuredItemAnchor = anchors?.guestAnchors?.find((anchor) => anchor.id === featuredItem.anchorId);
      }

      return buildAnchorCheckoutLink(featuredItem.anchorId,
        buildAnchorLink({ id: featuredItem?.anchorId, name: featuredItemAnchor?.name }));
    }

    if (type === 'past_clips' && featuredItem?.programSegments?.find((program) => program?.clip?.clipUrls !== null)) {

      return '#';
    }

    return featuredItem?.url;
  };

  formatTitle = (title) => {
    if (this.props.type === 'past_clips') {
      const utcDate = moment(title).utc();

      return utcDate.format('dddd, LL');
    }

    return title;
  };

  onHandleClick = () => {
    const { type, featuredItem } = this.props;
    if (type === 'past_clips' && featuredItem?.programSegments?.find((program) => program?.clip?.clipUrls !== null)) {
      this.props.setSelectedVideo(featuredItem);
    }
  };

  render() {
    const { featuredItem, type } = this.props;
    const title = featuredItem.name || featuredItem.title;
    const { anchors } = AnchorStore;
    const URL = this.getUrlForItem();

    return (
      <div className="content-item-container">
        <a className="content-item " href={URL} title={title} onClick={this.onHandleClick}>
          <LazyLoad offset={10}>
            {this.renderContent()}
          </LazyLoad>
          <div className="content-item-caption">
            <div className="content-item-title">
              {this.formatTitle(title)}
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export default FeaturedItem;
